<template>
  <div class="header" :style="{ 'background-color': bgColor }">
    <div class="header-box">
      <div class="header-box-left">
        <img src="../assets/LOGO.png" alt="" />
      </div>
      <div class="header-box-right">
        <div class="menu-box">
          <router-link tag="div" to="/index">首页</router-link>
          <router-link tag="div" to="/aboutOrisa">关于奥丽莎</router-link>
          <router-link tag="div" to="/productCenter">产品中心</router-link>
          <router-link tag="div" to="/newsCenter">新闻中心</router-link>
          <router-link tag="div" to="/joinOlivia">加盟奥丽莎</router-link>
          <router-link tag="div" to="/storeDistribution">门店分布</router-link>
          <router-link tag="div" to="/contactUs">联系我们</router-link>
        </div>
        <!-- <div class="menu-search">
          <img v-show="!searchShow" src="../assets/search.png" alt="" @mouseenter="searchEnter" />
            <input
              type="text"
              v-show="searchShow"
              placeholder="请搜索产品"
              @mouseenter="searchEnter"
              @mouseleave="searchleave"
            />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    bgColor: String,
  },
  data() {
    return {
      searchShow: false,
    };
  },
  methods: {
    searchEnter(e) {
      this.searchShow = true;
    },
    searchleave(e) {
      this.searchShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  z-index: 99;

  .header-box {
    width: 1500px;
    min-width: 1500px;
    margin: auto;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-box-left {
      img {
        width: 133px;
        // height: 59px;
        display: block;
      }
    }

    .header-box-right {
      display: flex;
      align-items: center;

      .menu-box {
        display: flex;
        align-items: center;

        > div {
          font-size: 14px;
          color: #ffffff;
          margin: 0 25px;
          cursor: pointer;
        }
      }

      .menu-search {
        margin-left: 20px;
        > img {
          width: 20px;
          height: 20px;
          display: block;
        }

        > input {
          width: 150px;
          height: 30px;
          font-size: 10px;
          color: #fff;
          outline: none;
          border: 0.5px solid #fff;
          padding: 0 10px;
          background-color: transparent;
          border-radius: 90px;

          &::placeholder {
            color: #fff;
          }
        }
      }
    }
  }
}

.router-link-active {
  color: #E7CE8D!important;
}
</style>
